import api from "lib/api";

export const getLeaveTypeCompany = async (params = {}) => {
  return await api.post("/v1/stp/getLeaveTypeCompany", params);
};

export const createLeaveTypeCompany = async (params = {}) => {
  return await api.post("/v1/stp/createLeaveTypeCompany", params);
};

export const updateLeaveTypeCompany = async (params = {}) => {
  return await api.post("/v1/stp/updateLeaveTypeCompany", params);
};

export const manageStatusLeaveTypeCompany = async (params = {}) => {
  return await api.post("/v1/stp/manageStatusLeaveTypeCompany", params);
};

export const getLeaveType = async (params = {}) => {
  return await api.post("/v1/stp/getLeaveType", params);
};

export const getPosition = async (params = {}) => {
  return await api.post("/v1/position/getPosition", params);
};

export const getPositionOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getPosition", params);
};

export const getLeaveEntitlement = async (params = {}) => {
  return await api.post("/v1/stp/getLeaveEntitlement", params);
};

export const updateLeaveTypeEntitlement = async (params = {}) => {
  return await api.post("/v1/stp/updateLeaveEntitlement", params);
};

export const getWorkFlowTypeByGroup = async (params = {}) => {
  return await api.post("/v1/workFlowMapping/getWorkFlowTypeByGroup", params);
};

export const getWorkFlowByType = async (params = {}) => {
  return await api.post("/v1/workFlowMapping/getWorkFlowByType", params);
};
export const editWorkFlow = async (params = {}) => {
  return await api.post("/v1/workFlowMapping/editWorkFlow", params);
};

export const resetToDefault = async (params = {}) => {
  return await api.post("/v1/workFlowMapping/resetToDefault", params);
};

export const getLeaveCategoryOption = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryForLeaveType", params);
};
export const dropdownWorkInLocation = async (params = {}) => {
  return await api.post("/v1/workInLocation/dropdownWorkInLocationForOffsite", params);
};

